const formdata = [
  {
    inputdata: "",
    title: "经销商名称",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "220px",
    lablewith: "90px",
  },
  {
    inputdata: "",
    title: "产品线",
    fontSize: "14px",
    color: "#333333",
    placeholder: "全部",
    types: "",
    inputtype: "select",
    width: "220px",
    btx: true,
    lablewith: "100px",
    options: [],
  },
  {
    inputdata: "",
    title: "指定配送商/采购代理",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "220px",
    lablewith: "100px",
  },
  // {
  //   inputdata: "",
  //   title: "服务商类型",
  //   fontSize: "14px",
  //   color: "#333333",
  //   placeholder: "全部",
  //   types: "",
  //   inputtype: "select",
  //   width: "190px",
  //   btx: true,
  //   lablewith: "90px",
  //   options: [],
  // },
  {
    inputdata: "",
    title: "下级经销商",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "220px",
    lablewith: "100px",
  },
  //   {
  //     inputdata: "",
  //     title: "医院分类",
  //     fontSize: "14px",
  //     color: "#333333",
  //     placeholder: "全部",
  //     types: "",
  //     inputtype: "select",
  //     width: "190px",
  //     btx: true,
  //     lablewith: "120px",
  //     options: [],
  //   },
  {
    inputdata: "",
    title: "医院名称",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "220px",
    lablewith: "90px",
  },
  {
    inputdata: "",
    title: "是否有终端医院发票",
    fontSize: "14px",
    color: "#333333",
    placeholder: "全部",
    types: "",
    inputtype: "select",
    width: "170px",
    btx: true,
    lablewith: "150px",
    options: [
      {
        key: "1",
        value: "是",
      },
      {
        key: "0",
        value: "否",
      },
    ],
  },
  {
    inputdata: "",
    title: "审核日期",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "",
    inputtype: "dateSection",
    widthLeft: 235,
    widthRight: 305,
    lablewith: "95px",
  },
  {
    inputdata: "",
    title: "创建日期",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "",
    inputtype: "date",
    width: "140px",
    lablewith: "85px",
  },
  {
    inputdata: "",
    title: "申请单号",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "300px",
    lablewith: "70px",
  },
  {
    inputdata: "",
    title: "状态",
    fontSize: "14px",
    color: "#333333",
    placeholder: "全部",
    types: "",
    inputtype: "select",
    width: "170px",
    btx: true,
    lablewith: "70px",
    options: [],
  }
];

export default formdata;
